module.exports = __webpack_public_path__ + "biologic-white-full.svg";